(function () {
    'use strict';

    angular.module("imApp").factory("travelBillsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1251,
                    parameters: parms || {}
                });
            },
            listLabours: function (parms) {
                return $ihttp.post({
                    method: 1252,
                    parameters: parms || {}
                });
            },
            listTravelBills: function (parms) {
                return $ihttp.post({
                    method: 1253,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
